import React from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import axios from "axios";
import { StatusEnum } from "../../constants/employeeStatusEnum";
import StatusOptions from "../../options/employeeStatusOptions";
import { designationOptions } from "../../options/designationOptions";
import { ThreeDots } from "react-loader-spinner";
import DeallocateShadowMember from "./DeallocateShadowMember";
import { API_SHADOW_RESOURCES } from "../../config/Endpoints";
export const EditMemberFormModal = ({
  openModal,
  closeModal,
  updateMember,
  project,
  shadowEmployeeList,
  mainEmployeeList,
  formData,
  setFormData,
  isLoading,
  isFormChanged,
}) => {
  const calculateStatus = (joinDate, endDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (endDate) {
      const end = new Date(endDate);
      end.setHours(0, 0, 0, 0);
      return end >= today ? StatusEnum.ACTIVE : StatusEnum.INACTIVE;
    }

    return joinDate ? StatusEnum.ACTIVE : "";
  };
  if (!openModal) return;

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content rounded-lg">
          <div className="modal-header">
            <h5 className="modal-title">Edit Shadow Member</h5>
            <button
              type="button"
              className="btn-close"
              onClick={closeModal}
            ></button>
          </div>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              updateMember();
            }}
          >
            <div
              className="modal-body py-5 px-4"
              style={{ backgroundColor: "#fafbff" }}
            >
              <div className="container-fluid">
                <div className="row justify-content-center">
                  <div className="col-md-10">
                    {/* Shadow Employee */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label
                          className="form-label mb-0"
                          style={{ color: "#333" }}
                        >
                          Shadow Employee
                        </label>
                      </div>
                      <div className="col-md-8">
                        <Select
                          options={shadowEmployeeList}
                          placeholder="Select Shadow Employee"
                          value={formData.shadowEmployee}
                          onChange={(val) =>
                            setFormData({ ...formData, shadowEmployee: val })
                          }
                          required
                        />
                      </div>
                    </div>

                    {/* Main Employee */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label
                          className="form-label mb-0 "
                          style={{ color: "#333" }}
                        >
                          Main Employee
                        </label>
                      </div>
                      <div className="col-md-8">
                        <Select
                          options={mainEmployeeList}
                          placeholder="Select Main Employee"
                          value={formData.mainEmployee}
                          onChange={(val) =>
                            setFormData({ ...formData, mainEmployee: val })
                          }
                          required
                        />
                      </div>
                    </div>

                    {/* Designation */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label
                          className="form-label mb-0 "
                          style={{ color: "#333" }}
                        >
                          Shadow Resource Designation
                        </label>
                      </div>
                      <div className="col-md-8">
                        <Select
                          options={designationOptions}
                          placeholder="Select Designation"
                          value={formData.designation}
                          onChange={(option) =>
                            setFormData({ ...formData, designation: option })
                          }
                        />
                      </div>
                    </div>

                    {/* Joining Date */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label
                          className="form-label mb-0"
                          style={{ color: "#333" }}
                        >
                          Joining Date
                        </label>
                      </div>
                      <div className="col-md-8">
                        <DatePicker
                          showIcon
                          toggleCalendarOnIconClick
                          placeholderText="mm/dd/yyyy"
                          selected={
                            formData.joiningDate
                              ? new Date(formData.joiningDate)
                              : null
                          }
                          minDate={
                            project?.sowStartDate
                              ? new Date(project.sowStartDate)
                              : null
                          }
                          maxDate={
                            project?.sowEndDate
                              ? new Date(project.sowEndDate)
                              : null
                          }
                          onChange={(date) =>
                            setFormData({
                              ...formData,
                              joiningDate: date,
                              status: StatusOptions.find(
                                (opt) =>
                                  opt.value ===
                                  calculateStatus(date, formData.endDate)
                              ),
                            })
                          }
                          required
                          onKeyDown={(e) => {
                            if (e.key !== "Backspace" && e.key !== "Delete")
                              e.preventDefault();
                          }}
                          className="border"
                          style={{
                            borderColor: "#e1e5f7",
                            borderRadius: "8px",
                            padding: "10px 12px",
                            fontSize: "14px",
                            backgroundColor: "#fff",
                          }}
                        />
                      </div>
                    </div>

                    {/* End Date */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label
                          className="form-label mb-0 "
                          style={{ color: "#333" }}
                        >
                          End Date
                        </label>
                      </div>
                      <div className="col-md-8">
                        <DatePicker
                          showIcon
                          toggleCalendarOnIconClick
                          placeholderText="mm/dd/yyyy"
                          selected={
                            formData.endDate ? new Date(formData.endDate) : null
                          }
                          minDate={
                            formData.joiningDate
                              ? new Date(formData.joiningDate)
                              : project?.sowStartDate
                              ? new Date(project.sowStartDate)
                              : null
                          }
                          maxDate={
                            project?.endDate
                              ? new Date(project.endDate)
                              : project?.sowEndDate
                              ? new Date(project.sowEndDate)
                              : null
                          }
                          onChange={(date) =>
                            setFormData({
                              ...formData,
                              endDate: date,
                              status: StatusOptions.find(
                                (opt) =>
                                  opt.value ===
                                  calculateStatus(formData.joiningDate, date)
                              ),
                            })
                          }
                          onKeyDown={(e) => {
                            if (e.key !== "Backspace" && e.key !== "Delete")
                              e.preventDefault();
                          }}
                          className="border"
                          style={{
                            borderColor: "#e1e5f7",
                            borderRadius: "8px",
                            padding: "10px 12px",
                            fontSize: "14px",
                            backgroundColor: "#fff",
                          }}
                        />
                      </div>
                    </div>

                    {/* Status */}
                    <div className="row mb-3 align-items-center">
                      <div className="col-md-4">
                        <label
                          className="form-label mb-0 "
                          style={{ color: "#333" }}
                        >
                          Status
                        </label>
                      </div>
                      <div className="col-md-8">
                        <Select
                          options={StatusOptions}
                          value={formData.status || null}
                          onChange={(option) =>
                            setFormData({ ...formData, status: option })
                          }
                          placeholder="Select Status"
                          isDisabled={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer rounded-lg-bottom">
              <button
                type="button"
                className="btn btn-secondary px-4 py-2"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn theme-button"
                disabled={isLoading || !isFormChanged}
              >
                {isLoading ? (
                  <ThreeDots
                    height="25"
                    width="80"
                    radius="9"
                    color="white"
                    ariaLabel="three-dots-loading"
                    visible={true}
                  />
                ) : (
                  "Save Changes"
                )}
              </button>
              <DeallocateShadowMember
                memberForm={formData}
                updateMember={updateMember}
                closeMemberModal={closeModal}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export const EditMembers = ({
  project,
  memberData,
  closeModal,
  openModal,
  shadowEmployeeList,
  mainEmployeeList,
  onMemberUpdate,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [formData, setFormData] = useState({
    shadowEmployee: memberData?.shadowEmployeeId
      ? {
          value: memberData.shadowEmployeeId,
          label: memberData.shadowEmployeeName,
        }
      : null,
    mainEmployee: memberData?.workingEmployeeId
      ? {
          value: memberData.workingEmployeeId,
          label: memberData.workingEmployeeName,
        }
      : null,
    joiningDate: memberData?.joiningDate
      ? new Date(memberData.joiningDate)
      : null,
    endDate: memberData?.endDate ? new Date(memberData.endDate) : null,
    status:
      memberData?.status !== undefined
        ? StatusOptions.find((opt) => opt.value === memberData.status)
        : null,
    designation: memberData?.designation
      ? designationOptions.find((opt) => opt.value === memberData.designation)
      : null,
  });

  const [initialFormData] = useState({
    shadowEmployee: memberData?.shadowEmployeeId
      ? {
          value: memberData.shadowEmployeeId,
          label: memberData.shadowEmployeeName,
        }
      : null,
    mainEmployee: memberData?.workingEmployeeId
      ? {
          value: memberData.workingEmployeeId,
          label: memberData.workingEmployeeName,
        }
      : null,
    joiningDate: memberData?.joiningDate
      ? new Date(memberData.joiningDate)
      : null,
    endDate: memberData?.endDate ? new Date(memberData.endDate) : null,
    status:
      memberData?.status !== undefined
        ? StatusOptions.find((opt) => opt.value === memberData.status)
        : null,
    designation: memberData?.designation
      ? designationOptions.find((opt) => opt.value === memberData.designation)
      : null,
  });
  const isFormChanged =
    JSON.stringify(formData) !== JSON.stringify(initialFormData);

  const toUTCDateString = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00:00`;
  };

  const updateMember = async (
    updatedForm = null,
    triggerMainLoading = true
  ) => {
    try {
      if (triggerMainLoading) setIsLoading(true);
      const formToSend = updatedForm || formData;

      if (formToSend.joiningDate && formToSend.endDate) {
        const join = new Date(formToSend.joiningDate);
        const end = new Date(formToSend.endDate);
        join.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        if (end < join) {
          toast.error("End date must be after or equal to joining date!", {
            position: toast.POSITION.TOP_RIGHT,
          });
          if (triggerMainLoading) setIsLoading(false);
          return;
        }
      }

      const payload = {
        shadowEmployeeId: formToSend.shadowEmployee?.value,
        workingEmployeeId: formToSend.mainEmployee?.value,
        projectId: project?.projectId,
        joiningDate: toUTCDateString(formToSend.joiningDate),
        endDate: toUTCDateString(formToSend.endDate),
        status: formToSend.status?.value,
        designation: formToSend.designation?.value,
        createdBy: String(userData?.id),
      };

      const accessToken = Cookies.get("accessToken");

      const res = await axios.put(
        `${API_SHADOW_RESOURCES}/${memberData.id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status >= 200 && res.status < 300) {
        toast.success(res?.data?.message || "Member updated successfully");

        onMemberUpdate({
          ...memberData,
          shadowEmployeeId: formToSend.shadowEmployee?.value,
          shadowEmployeeName: formToSend.shadowEmployee?.label,
          workingEmployeeId: formToSend.mainEmployee?.value,
          workingEmployeeName: formToSend.mainEmployee?.label,
          joiningDate: toUTCDateString(formToSend.joiningDate),
          endDate: toUTCDateString(formToSend.endDate),
          status: formToSend.status?.value,
          designation: formToSend.designation?.value,
        });
        if (triggerMainLoading) closeModal();
        return true;
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update member.");
      throw error;
    } finally {
      if (triggerMainLoading) setIsLoading(false);
    }
  };

  return (
    <EditMemberFormModal
      openModal={openModal}
      closeModal={closeModal}
      updateMember={updateMember}
      project={project}
      formData={formData}
      setFormData={setFormData}
      shadowEmployeeList={shadowEmployeeList}
      mainEmployeeList={mainEmployeeList}
      isLoading={isLoading}
      isFormChanged={isFormChanged}
    />
  );
};
